export const CHECKOUT_SESSION_OWNERSHIP_TOKEN_HEADER =
  "X-Checkout-Session-Ownership-Token" as const;

export type CheckoutSessionOwnershipToken = string;
